import { ref, inject, provide, readonly, Ref, watch } from 'vue'

// symbol key in store
const SymStore = Symbol('Store')

// store data
const state: {[key: string]: Ref | any} = {
  user: ref({}), // data of user
  isFromAgency: ref(false)
}

export const provideStore = () => {
  provide(SymStore, readonly(state))
}

export const Watch = (key: string, callback: any) => {
  watch(state[key], (nkey: any, okey: any) => {
    callback(nkey, okey)
  })
}

export const useStore = () => {
  return inject(SymStore)
}

export const getters = (key?: string) => {
  if (key) {
    return readonly(state[key]).value
  } else {
    return readonly(state)
  }
}

export const commit = (key: string, data: any) => {
  console.info('Commit => state', key, data)
  return (state[key] as Ref).value = data
}